import {
  ADD_UPDATE_PIAGGIO_CUSTOMER_FAILURE,
  ADD_UPDATE_PIAGGIO_CUSTOMER_REQUEST,
  ADD_UPDATE_PIAGGIO_CUSTOMER_SUCCESS,
  FETCH_PIAGGIO_CUSTOMER_LIST_FAILURE,
  FETCH_PIAGGIO_CUSTOMER_LIST_REQUEST,
  FETCH_PIAGGIO_CUSTOMER_LIST_SUCCESS,
} from "./actionTypes";
import { PiaggioCustomerState } from "./types";

// Initial state for customer reducer
const initialCustomerState: PiaggioCustomerState = {
  piaggioCustomersList: [],
  loading: false,
  error: null,
  totalCount: 0,
  successMessage: null,
};

// Customer reducer
const piaggioCustomerReducer = (
  state = initialCustomerState,
  action: any
): PiaggioCustomerState => {
  switch (action.type) {
    case FETCH_PIAGGIO_CUSTOMER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PIAGGIO_CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        piaggioCustomersList:
          action.payload.piaggioCustomerList || action.payload,
        totalCount: action.payload.totalCount || 0,
      };

    case FETCH_PIAGGIO_CUSTOMER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_UPDATE_PIAGGIO_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ADD_UPDATE_PIAGGIO_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload,
      };

    case ADD_UPDATE_PIAGGIO_CUSTOMER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default piaggioCustomerReducer;
